import { render } from "./BorrowLender.vue?vue&type=template&id=06ae5942&scoped=true"
import script from "./BorrowLender.vue?vue&type=script&lang=js"
export * from "./BorrowLender.vue?vue&type=script&lang=js"

import "./BorrowLender.vue?vue&type=style&index=0&id=06ae5942&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ae5942"]])

export default __exports__